import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000,     
      gcTime: 60 * 60 * 1000,        
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
